import { OrderCustomerActionDTOTypeIdEnum } from '@reposit/api-client';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { REPOSIT_PAYMENT_WARNING } from '../../constants/reposit';
import { getCurrentCustomerId } from '../../redux/account/account.selectors';
import { createLoadingSelector } from '../../redux/loading/loading.selector';
import {
  getClaimPaymentIntentRequested,
  GET_CLAIM_PAYMENT_INTENT_STORE_KEY,
  payRequested,
  PAY_STORE_KEY,
} from '../../redux/order-customer-actions/order-customer-actions.actions';
import {
  getClaimPaymentIntentSecret,
  getIsPollingForPaymentCompletion,
} from '../../redux/order-customer-actions/order-customer-actions.selectors';
import { PaymentType } from '../../redux/order-customer-actions/order-customer-actions.types';
import { fetchOrderCustomerRequested, FETCH_ORDER_CUSTOMER_STORE_KEY } from '../../redux/order/order.actions';
import { getCurrentOrderCustomer } from '../../redux/order/order.selectors';
import PaymentContainer from '../Payment';
import Loading from '../../components/Loading';

interface ClaimProposalPaymentProps {
  orderId: string;
}

const WarningMessage = () => {
  return (
    <>
      <div>
        You must provide full payment for this proposal to be considered. If this payment is not provided, these end of tenancy
        charges will be considered accepted and you will take full liability of the charges.
      </div>
      <div style={{ marginTop: '1em' }}>{REPOSIT_PAYMENT_WARNING}</div>
    </>
  );
};

const ClaimProposalPayment: React.FC<ClaimProposalPaymentProps> = ({ orderId }) => {
  const dispatch = useDispatch();
  const currentCustomerId = useSelector(getCurrentCustomerId);
  // NEEDS TO CHANGE
  const paymentIntentSecret = useSelector(getClaimPaymentIntentSecret);
  const getPayRepositLoadingSelector = createLoadingSelector([PAY_STORE_KEY]);
  const isPaymentLoading = useSelector(getPayRepositLoadingSelector);
  const currentOrderCustomer = useSelector(getCurrentOrderCustomer);
  const amount = get(currentOrderCustomer, 'fee');
  const pageLoadingSelector = createLoadingSelector([FETCH_ORDER_CUSTOMER_STORE_KEY, GET_CLAIM_PAYMENT_INTENT_STORE_KEY]);
  const isPageLoading = useSelector(pageLoadingSelector);
  const isPolling = useSelector(getIsPollingForPaymentCompletion);

  useEffect(() => {
    if (orderId && currentCustomerId) {
      dispatch(
        getClaimPaymentIntentRequested(
          currentCustomerId,
          orderId,
          OrderCustomerActionDTOTypeIdEnum.CLAIMPROPOSALPAYREMAININGBALANCE
        )
      );
      dispatch(
        fetchOrderCustomerRequested({
          customerId: currentCustomerId,
          orderId,
          source: {
            sourceType: 'route-load',
            sourceName: 'claim-proposal-payment-page',
            route: window.location.pathname,
            reason: 'claim-proposal-payment-load',
          },
        })
      );
    }
  }, [dispatch, currentCustomerId, orderId]);

  const submitPayment = (stripe: Stripe, elements: StripeElements) =>
    dispatch(payRequested({ stripe, paymentIntentSecret, type: PaymentType.CLAIM_PROPOSAL, elements }));

  const isLoading = isPageLoading || isPolling || isPaymentLoading;

  const render = () => {
    return amount ? (
      <PaymentContainer
        fullWidth
        isSubmitting={isLoading}
        amount={`${amount}`}
        submitCard={submitPayment}
        type={PaymentType.CLAIM_PROPOSAL}
        warningMessage={WarningMessage}
        title="Pay your proposal"
        redWarningMessage={false}
        paymentMode={`payment`}
      />
    ) : (
      <Loading />
    );
  };

  return render();
};

export default ClaimProposalPayment;
